import * as React from "react";

export const AsphaltPolyfillLoader = React.lazy(
  () => import("./AsphaltPolyfill.loader")
);

const browserSupportsCSSVariables = () =>
  window.CSS?.supports?.("color", "var(--fake-var)");

export const AsphaltPolyfill = () => (
  <React.Suspense fallback={null}>
    {!browserSupportsCSSVariables() && <AsphaltPolyfillLoader />}
  </React.Suspense>
);
